<span fxLayout="row" fxLayoutAlign="center center">
  <div fxLayout="row" fxFlex="0 1 900px" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="space-between center"
    fxLayoutGap="20px" fxFill>
    <a (click)="onLogoClick()" tabindex="0" aria-label="Zur Einstiegseite"
      class="text-decoration-none black clickable primary-color text-wrap outline-none pl20px-LOCAL" fxLayout="row"
      fxLayout.xs="column" fxFlexAlign="start start" fxLayoutGap="10px" fxLayoutGap.xs="4px">
      <img ngSrc="assets/media/provisional_logo.svg" priority width=134 height=24 alt="FLIMMO">
      <h1 *ngIf="router.url === '/' || router.url.startsWith('/?'); else notH" fxLayout="column"
        class="h1-nomargin f-slogan primary-color">
        <span>Elternratgeber für </span>
        <span>TV, Streaming & YouTube</span>
      </h1>
      <ng-template #notH>
        <span fxLayout="column" class="f-slogan primary-color">
          <span>Elternratgeber für</span>
          <span>TV, Streaming & YouTube</span>
        </span>
      </ng-template>
    </a>
    <div fxLayout="row" fxLayoutAlign="center center">
      <a aria-label="Flimmo auf Instagram folgen" role="link" fxLayoutAlign="center center" class="p10px"
        href="https://www.instagram.com/flimmo.elternratgeber/" target="_blank">
        <img ngSrc="assets/media/insta.svg" width=20 height=20 [alt]="'layout.header.insta' | translate">
      </a>
      <a aria-label="Flimmo auf Facebook folgen" role="link" fxLayoutAlign="center center" class="p10px"
        href="https://www.facebook.com/flimmo.elternratgeber/" target="_blank">
        <img ngSrc="assets/media/fb.svg" width=16 height=16 [alt]="'layout.header.facebook' | translate">
      </a>
      <a aria-label="Flimmo auf Whatsapp folgen" role="link" fxLayoutAlign="center center" class="p10px"
        href="https://whatsapp.com/channel/0029VauNZHx6xCSPLGZnRZ0t" target="_blank">
        <img ngSrc="assets/media/whatsapp.svg" width=20 height=20 [alt]="'layout.header.whatsapp' | translate">
      </a>
    </div>
    <span fxLayout="row">
      <span fxLayout="row" fxLayoutGap="10px" class="desktop-only">
        <span fxLayout="row" fxFlexAlign="center center" class="align-self-center" fxLayoutGap="10px">
          <a fxLayout="row" fxFlexAlign="center center"
            class="align-items-center justify-content-center flimmo-outline-button f-button-label text-decoration-none custom-header-button"
            routerLink="/redtext/101469/Mediennutzung-kompetent-begleiten">{{'layout.header.menuItems.redtext' |
            translate | uppercase}}</a>
          <a fxLayout="row" fxFlexAlign="center center"
            class="align-items-center text-nowrap justify-content-center flimmo-outline-button f-button-label text-decoration-none custom-header-button"
            routerLink="/ueber-flimmo">{{'layout.header.menuItems.about' | translate | uppercase}}</a>
        </span>
      </span>
      <span>
        <button mat-icon-button [matMenuTriggerFor]="navmenu" disableRipple class="mobile-only menu-button-wrapper"
          aria-label="Menü">
          <mat-icon class="menu-button" color="primary">menu</mat-icon>
        </button>
      </span>
    </span>
  </div>
</span>

<mat-menu #navmenu="matMenu" class="mat-app-background-1">
  <a class="text-decoration-none mat-transparent black f-hint-link" mat-menu-item
    routerLink="/redtext/101469/Mediennutzung-kompetent-begleiten">{{'layout.header.menuItems.redtext' | translate |
    uppercase}}</a>
  <a class="text-decoration-none mat-transparent black f-hint-link button-border" mat-menu-item
    routerLink="/ueber-flimmo">{{'layout.header.menuItems.about' | translate | uppercase}}</a>
</mat-menu>